import React, { ReactNode, memo } from 'react';

import styles from './menu.module.css';
import classNames from 'classnames';

type Props = {
	children: ReactNode;
	theme?: 'light' | 'dark';
};

export const MenuSeparator = memo(() => <div className={styles.separator} />);

/**
 * Menu Component
 */
export const Menu: React.FC<Props> = ({ theme = 'dark', children }) => {
	return (
		<ul
			className={classNames(styles.list, {
				[styles.dark]: theme === 'dark',
				[styles.light]: theme === 'light',
			})}
		>
			{children}
		</ul>
	);
};
